import { Component, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { FilesService } from 'src/app/_services/files/files.service';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';


@Component({
  selector: 'app-view-attachment',
  templateUrl: './view-attachment.component.html',
  styleUrls: ['./view-attachment.component.scss']
})
export class ViewAttachmentComponent {

  @Input() rxAttachmentUrl: string | undefined;
  rxAttachmentSafeUrl: SafeResourceUrl | undefined;

  ngOnInit() {
    if (this.rxAttachmentUrl) {
      this.rxAttachmentSafeUrl = this.sanitizer.bypassSecurityTrustResourceUrl(this.rxAttachmentUrl);
    }
  }

  constructor(
    public activeModal: NgbActiveModal,
    private fileService: FilesService,
    private sanitizer: DomSanitizer) {} 

  isImage(url: string): boolean {
      const imageExtensions = ['.jpg', '.jpeg', '.png', '.gif', '.bmp', '.svg', '.tiff', '.webp', '.ico'];
      const lowerCaseUrl = url.toLowerCase();
      return imageExtensions.some(ext => lowerCaseUrl.endsWith(ext));
  }

  isPdf(url: string): boolean {
      return url.toLowerCase().endsWith('.pdf');
  }

  closeModal() {
    this.activeModal.dismiss();
}

downloadRxFile() {
  this.fileService.downloadFile(this.rxAttachmentUrl);
}
}
